import {constants} from "../../../constants";

export default class CloseHelp {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.web.closeHelp();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.EDIG:
                event["closeHTML"] = this._default;
                break;
            default:
                event["closeHelp"] = this._default
        }

        return event;
    }
}
